import React from 'react'
import { Linking } from 'react-native'
import { faCircleUser } from '@fortawesome/pro-regular-svg-icons'
import { useParams } from '../../Router'
import { IconWrapper } from './style'
import { FaIcon } from '../../App/Components'
import { ISettingValues } from '../../Settings/ISettings'
import { customerPortalLinks } from '../../App/Util/customerPortalUrl'

interface IProps {
  settingValues: ISettingValues
}

export const AccountIcon = ({ settingValues }: IProps) => {
  const { establishmentId } = useParams()

  if (typeof settingValues === 'undefined') {
    return null
  }

  return (
    <IconWrapper
      $isMessage={settingValues.message}
      onPress={() => Linking.openURL(customerPortalLinks.profile(establishmentId))}
    >
      <FaIcon
        size="lg"
        icon={faCircleUser}
        color={settingValues.highlightColor}
      />
    </IconWrapper>
  )
}
